import { GridColDef } from "@mui/x-data-grid";
import "../../css/global.css";

interface ColumnsProps {
  handleVerClick: (uuid: string, link: string) => void;
  urlOrigen?: string;
  rows: any[];
}

const getColumnsSolicitudPF = ({
  handleVerClick,
  urlOrigen,
  rows
}: ColumnsProps): GridColDef[] => {
  const formatNumber = (value: any) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const columns: GridColDef[] = [
    {
      field: "Municipio",
      headerName: "Municipios",
      width: 150,
      hideable: false,
      headerAlign: "left",
      align: "left",

      renderCell: (cellValues: any) => {
        return <p>{cellValues.row.Municipio}</p>;
      },

    },
    {
      field: "FGP",
      headerName: "Fondo General Participaciones",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FGP)}</p>;
      },
    },
    {
      field: "FFM70",
      headerName: "Fondo de Fomento Municipal 70 % (FFM70)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FFM70)}</p>;
      },
    },
    {
      field: "FFM30",
      headerName: "Fondo de Fomento Municipal 30 % (FFM30)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FFM30)}</p>;
      },
    },
    {
      field: "IEPS",
      headerName: "Impuesto Especial sobre la Producción y los Servicios (IEPS)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.IEPS)}</p>;
      },
    },
    {
      field: "FOFIR",
      headerName: "Fondo de Fiscalización y Recaudación",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.FOFIR)}</p>;
      },
    },
    {
      field: "ISAN",
      headerName: "Impuesto sobre Automoviles Nuevos (ISAN)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.ISAN)}</p>;
      },
    },
    {
      field: "COMP ISAN",
      headerName: "Fondo de Compensación de ISAN",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "IEPSGyD",
      headerName: "Impuesto Especial sobre la Venta Final de Gasolina y Diésel (IEPSGyD)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.row.IEPSGyD)}</p>;
      },
    },
    {
      field: "FEXHI",
      headerName: "Fondo de Extracción de Hidrocarburos",
      width:300,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "ISR INMUEBLES",
      headerName: "ISR por Enajenación de Bienes Inmuebles",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "ISR SALARIOS",
      headerName: "ISR Salarios",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FGP",
      headerName: "FEIEF Fondo General Participaciones",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FOFIR",
      headerName: "FEIEF Fondo de Fiscalización y Recaudación",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF FFM70",
      headerName: "FEIEF Fondo de Fomento Municipal 70 % (FFM70)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "FEIEF IEPS",
      headerName: "FEIEF Impuesto Especial sobre la Producción y los Servicios (IEPS)",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
    {
      field: "TOTALES",
      headerName: "Totales",
      width: 150,
      hideable: false,
      headerAlign: "center",
      align: "right",
      renderCell: (cellValues: any) => {
        return <p>{formatNumber(cellValues.value)}</p>;
      },
    },
  ];
  const filteredColumns = columns.filter((col) => {
    // "municipio" siempre aparece
    if (col.field === "municipio") return true;

    // ¿Hay algún valor numérico distinto de cero?
    return rows.some((row) => {
      const raw = row[col.field];

      // vacío, null o undefined ⇒ descartar esta fila
      if (raw === undefined || raw === null || raw === "") return false;

      // si es string, intentar parsear como número (quita comas)
      const num =
        typeof raw === "string" ? parseFloat(raw.replace(/,/g, "")) : raw;

      // si no es número (NaN), considérese valor “significativo”
      if (isNaN(num)) return true;

      // incluir columna si al menos un número es distinto de cero
      return num !== 0;
    });
  });

  return filteredColumns;
};

export default getColumnsSolicitudPF;
